import { createFileRoute, redirect } from "@tanstack/react-router";

// To order is the Orders page's first section now (ADR 0019); old links still arrive there.
export const Route = createFileRoute("/to-order")({
  beforeLoad: () => {
    throw redirect({ to: "/orders" });
  },
});
